<template>
  <div id="select-service-clinic-names">
    <v-select
      class="style-chooser"
      :placeholder="placeholderTextDesktop"
      v-if="cx_serviceClinicNames"
      :options="cx_serviceClinicNames"
      v-model="cx_selectedServiceClinicName"
      @option:selected="$emit('changeServiceClinicName', cx_selectedServiceClinicName)"
      label="name"
    >
      <template v-slot:option="option">
        <div class="d-flex justify-content-between">
          <div class="name-option open-sans-font">
            {{ option.name }}
          </div>
          <div class="info-option open-sans-font">
            <div v-if="$route.name != 'ClinicScreen'" class="title-info open-sans-font">
              Valor Médio
            </div>
            <div v-if="$route.name === 'ClinicScreen'" class="title-info open-sans-font">
              Pague na Farmácia
            </div>
            {{ formatCurrency(option.price) }}
          </div>
        </div>
      </template>
      <template #no-options>
        <span class="open-sans-font">Não foram encontrados serviços</span>
      </template>
    </v-select>

    <div class="mobile-input">
      <input
        type="text"
        class="form-control open-sans-font"
        :placeholder="placeholderTextMobile"
        :value="!!cx_selectedServiceClinicName ? cx_selectedServiceClinicName.name : ''"
        v-on:focus="toogleSearchModal"
      />
    </div>
    <div class="mobile-search-modal" v-if="cx_isOpenMobileModal">
      <div class="mobile-modal-header">
        <router-link class="logo img-fluid" :to="{ name: 'Home' }">
          <img :src="cx_logo" loading="lazy"/>
        </router-link>
      </div>
      <div class="mobile-modal-body">
        <div class="mobile-modal-row d-flex align-items-center">
          <div class="modal-row-content d-flex align-items-center w-100">
            <div class="mobile-modal-row-left">
              <input
                type="text"
                class="mobile-modal-input open-sans-font"
                v-model="cx_searchText"
                placeholder="Pesquise um serviço farmaceutico"
              />
            </div>
            <div class="mobile-modal-row-right d-flex justify-content-end">
              <button class="mobile-cancel-button open-sans-font" v-on:click="toogleSearchModal">
                Cancelar
              </button>
            </div>
          </div>
        </div>
        <div
          class="mobile-modal-row d-flex align-items-center"
          v-for="serviceName in filterServiceClinicNames()"
          v-bind:key="serviceName.id"
          v-on:click="selectServiceClinicName(serviceName)"
        >
          <div class="modal-row-content d-flex align-items-center w-100">
            <div class="mobile-modal-row-left">
              <div class="name-option open-sans-font">
                {{ serviceName.name }}
              </div>
            </div>
            <div class="mobile-modal-row-right">
              <div class="info-option open-sans-font">
                <div v-if="$route.name != 'ClinicScreen'" class="title-info open-sans-font">
                  Valor Médio
                </div>
                <div v-if="$route.name === 'ClinicScreen'" class="title-info open-sans-font">
                  Pague na Farmácia
                </div>
                {{ formatCurrency(serviceName.price) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectServiceClinic from "@/components/Util/SelectServiceClinic/SelectServiceClinic";
export default SelectServiceClinic;
</script>

<style lang="scss">
@import "SelectServiceClinic.scss";
</style>
